export enum SystemNotificationStatusTypeEnum {
  DANGER = 'danger',
  INFO = 'info',
  WARN = 'warn'
}
